import { useState, useEffect } from 'react';
import { api } from 'app/store';
import { IShard } from 'api';
import { fetchShardsSuccess } from 'utilities';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

export function useShards(isAuthorized: boolean, activeShard: IShard | null, skipWhenActiveShard = false) {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [shards, setShards] = useState<IShard[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const onDataLoad = (data: IShard[]) => {
    setShards(Array.isArray(data) ? data : []);
    dispatch(fetchShardsSuccess(data));
  };

  useEffect(() => {
    if (!isAuthorized) {
      setShards([]);
      setLoading(false);
      return;
    }

    if (skipWhenActiveShard && activeShard?.id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setShards([]);

    api.shard
      .list()
      .then(onDataLoad)
      .catch((error) => {
        const errorMessage = error?.message || 'Failed to load shards';
        addToast(errorMessage, { appearance: 'error' });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized, activeShard?.id, skipWhenActiveShard]);

  return {
    shards,
    loading,
  };
}
